import React, { FC, useContext } from 'react';
import { RegularButton, Typography } from 'fronton-react';
import { ProductPriceView } from 'common/components/product-price-view';
import { useTranslation } from 'react-i18next';
import { priceView, verticalButton } from './styles';
import { cx } from 'linaria';
import { OrientationContext } from '../../service-card';

export const DATA_QA_SERVICE_BUTTON = 'service-card-button';
export const DATA_QA_SERVICE_PRICE = 'service-price';

type Props = {
  price: number;
  className?: string;
  textClassName?: string;
  priceClassName?: string;
};

export const ServiceCardButton: FC<Props> = ({ price, className, textClassName, priceClassName }) => {
  const { t } = useTranslation();
  const vertical = useContext(OrientationContext);
  return (
    <RegularButton
      data-qa={DATA_QA_SERVICE_BUTTON}
      size="s"
      invert
      variant="primary"
      className={cx(className, vertical ? verticalButton : null)}
    >
      <Typography variant="s" size="subtitle" color="text-primary" className={textClassName}>
        {t('related-services.from')}
      </Typography>
      <ProductPriceView
        data-qa={DATA_QA_SERVICE_PRICE}
        variant="subtitle"
        className={cx(priceView, priceClassName)}
        unit={null}
        intPart={`${price}`}
        currency={t('ui.currency')}
      />
    </RegularButton>
  );
};
